/**
 * Created by eliasmj on 21/09/2015.
 */
angular.module('qkr.mssConfig')
    .factory('mssConfigService', ($http, appConfig, $q) => {
        let currentMessages;

        const service = {

            getTranslationsReports() {
                const deffered = $q.defer();

                $http.get(appConfig.contextPath + '/config/translationsReports')
                    .then((response) => {
                        deffered.resolve(response.data);
                    }, (reason) => {
                        deffered.reject(reason);
                    });

                return deffered.promise;
            },

            getCurrentMessages() {
                return currentMessages;
            },

            setCurrentMessages(messages) {
                currentMessages = messages;
            },

            getHotTranslation() {
                const deffered = $q.defer();

                $http.get(appConfig.contextPath + '/config/loadHotTranslation')
                    .then((response) => {
                        deffered.resolve(response.data);
                    }, (reason) => {
                        deffered.reject(reason);
                    });

                return deffered.promise;
            }

        };

    return service;
});



// WEBPACK FOOTER //
// ./src/mssConfig/services/mssConfigService.js